(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/account-selector/assets/javascripts/use-account.js') >= 0) return;  svs.modules.push('/components/marketplace/account-selector/assets/javascripts/use-account.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const marketplace = svs.components.marketplace;
const roles = svs.core.userSession.roles;
const _svs$ui$dialog = svs.ui.dialog,
  Confirm = _svs$ui$dialog.Confirm,
  branding = _svs$ui$dialog.branding,
  message = _svs$ui$dialog.message,
  api = _svs$ui$dialog.api,
  type = _svs$ui$dialog.type;
const queryString = svs.utils.url.queryString;
const logger = svs.core.log.getLogger('account-selector');
const useAccount = (drawNumber, productId) => {
  const _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    marketplaceAccount = _useState2[0],
    setMarketplaceAccount = _useState2[1];
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    accountBalance = _useState4[0],
    setAccountBalance = _useState4[1];
  const _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    accounts = _useState6[0],
    setAccounts = _useState6[1];
  const noAccountWarning = () => {
    const dialog = new Confirm({
      branding: branding.SPORT,
      icon: 'target',
      type: type.ERROR,
      title: 'Något gick fel!',
      message: [{
        type: message.TEXT,
        text: "Kopplingen till spela tillsammans f\xF6rsvann."
      }],
      actions: [{
        title: 'Okej',
        callback: () => {
          dialog.close();
        }
      }]
    });
    api.add(dialog);
  };
  useEffect(() => {
    if (!marketplaceAccount || marketplaceAccount && accountBalance !== marketplaceAccount.balance) {
      svs.components.account_balance.get(false, balance => {
        setAccountBalance(parseInt(balance, 10));
      });
    }
  }, [accountBalance, marketplaceAccount]);
  useEffect(() => {
    const onAccountSelectorDataChange = _ref => {
      let currentAccount = _ref.currentAccount,
        accounts = _ref.accounts;
      setMarketplaceAccount(currentAccount);
      setAccounts(accounts);
      const balance = currentAccount ? currentAccount.balance : accountBalance;
      if (balance !== accountBalance && currentAccount) {
        setAccountBalance(currentAccount.balance);
      }
    };
    if (marketplace && marketplace.accountSelector && (svs.core.userSession.hasRole(roles.PLAYER) || svs.core.userSession.hasRole(roles.RETAILER))) {
      marketplace.accountSelector.helpers.observer.subscribe(onAccountSelectorDataChange, {
        emitCurrentValue: true
      });
    }
    return () => {
      marketplace.accountSelector.helpers.observer.unsubscribe(onAccountSelectorDataChange);
    };
  }, [accountBalance]);
  useEffect(() => {
    if (!marketplaceAccount || accountBalance !== marketplaceAccount.balance) {
      marketplace.accountSelector.helpers.observer.notify({
        drawNumber,
        productId,
        userAccountBalance: accountBalance
      });
    }
  }, [accountBalance, drawNumber, marketplaceAccount, productId]);
  useEffect(() => {
    marketplace.accountSelector.helpers.fetchGames({
      drawNumber,
      productId,
      options: {
        ignoreCache: true
      }
    }, err => {
      if (err) {
        logger.info('❌ account not connected, errorCode:', err.responseJSON.error.code);
        const shouldShowDialog = queryString.fromPlayTogether === 'true' || queryString.isRetailerAdmin === 'true';
        if (shouldShowDialog) {
          noAccountWarning();
        }
      }
    });
  }, [drawNumber, productId]);
  return {
    marketplaceAccount,
    accountBalance,
    hasMarketplaceAccount: accounts || marketplace.accountSelector.helpers.observer.getValue().accounts.length > 0
  };
};
setGlobal('svs.components.marketplace.accountSelector.useAccount', useAccount);

 })(window);